import { DRIVER_ROLES } from "@/lib/roles/turboLogisticsRoles";

export function passesDriverAppRoleGate(hasRole: (...roles: string[]) => boolean): boolean {
  return DRIVER_ROLES.some((r) => hasRole(r));
}
